import React, { PropsWithChildren } from 'react'
import {MdClose} from 'react-icons/md'
import AriaModal from 'react-aria-modal'
import classnames from 'classnames';
import { WithTranslation, withTranslation } from 'react-i18next';

type ModalInternalProps = PropsWithChildren & {
  "data-wd-key"?: string
  isOpen: boolean
  title: string
  onOpenToggle(value: boolean): unknown
  underlayClickExits?: boolean
  underlayProps?: any
  className?: string
} & WithTranslation;


class ModalInternal extends React.Component<ModalInternalProps> {
  static defaultProps = {
    underlayClickExits: true
  }

  // Blur first and close on the next tick, or the closing click can reach
  // whatever sits under the dialog.
  onClose = () => {
    if (document.activeElement) {
      (document.activeElement as HTMLElement).blur();
    }

    setTimeout(() => {
      this.props.onOpenToggle(false);
    }, 0);
  }

  render() {
    const t = this.props.t;
    if(this.props.isOpen) {
      return <AriaModal
        titleText={this.props.title}
        underlayClickExits={this.props.underlayClickExits}
        // @ts-ignore
        underlayProps={this.props.underlayProps}
        underlayClass="studio-modal-underlay"
        data-wd-key={this.props["data-wd-key"]}
        verticallyCenter={true}
        onExit={this.onClose}
      >
        <div className={classnames("studio-modal", this.props.className)}
          data-wd-key={this.props["data-wd-key"]}
        >
          <header className="studio-modal-header">
            <h1 className="studio-modal-header-title">{this.props.title}</h1>
            <span className="studio-modal-header-space"></span>
            <button className="studio-modal-header-toggle"
              title={t("Close modal")}
              onClick={this.onClose}
              data-wd-key={this.props["data-wd-key"]+".close-modal"}
            >
              <MdClose />
            </button>
          </header>
          <div className="studio-modal-scroller">
            <div className="studio-modal-content">{this.props.children}</div>
          </div>
        </div>
      </AriaModal>
    }
    else {
      return false;
    }
  }
}

const Modal = withTranslation()(ModalInternal);
export default Modal;
